export default __webpack_public_path__ + "static/media/GABS.ade11f8b.jpg";